function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
import { useEffect, useRef } from 'react';
import favicon from '../../public/favicon.ico';
/**
 * Custom hook to set the document's favicon based on the logo content
 * from the configuration state.
 *
 * It handles both direct image URLs and inline SVG strings by converting the latter
 * into a Data URL.
 *
 * @param header_logo The header logo image URL or SVG string
 * @param shouldShow Whether to show the favicon (default: true)
 */
/**
 * Determines the href and type for a favicon link based on logo content
 */
var getFaviconProperties = function getFaviconProperties(logo) {
    var trimmedLogo = logo.trim();
    // SVG string
    if (trimmedLogo.startsWith('<svg')) {
        var encodedSvg = encodeURIComponent(trimmedLogo);
        return {
            href: "data:image/svg+xml;charset=utf-8,".concat(encodedSvg),
            type: 'image/svg+xml'
        };
    }
    // Base64 data URL
    if (logo.startsWith('data:image/')) {
        var mimePattern = /data:image\/([^;]+)/;
        var mimeMatch = mimePattern.exec(logo);
        return {
            href: logo,
            type: mimeMatch ? "image/".concat(mimeMatch[1]) : 'image/x-icon'
        };
    }
    // Direct URL - determine type from extension
    var typeMap = {
        '.svg': 'image/svg+xml',
        '.png': 'image/png',
        '.jpg': 'image/jpeg',
        '.jpeg': 'image/jpeg'
    };
    var extension = Object.keys(typeMap).find(function (ext) {
        return logo.endsWith(ext);
    });
    return {
        href: logo,
        type: extension ? typeMap[extension] : 'image/x-icon'
    };
};
/**
 * Creates and appends a favicon link element to the document head
 */
var createFaviconLink = function createFaviconLink(href, type) {
    var link = document.createElement('link');
    link.rel = 'icon';
    link.href = href;
    link.type = type;
    document.getElementsByTagName('head')[0].appendChild(link);
};
/**
 * Removes all existing favicon links from the document head
 */
var removeExistingFavicons = function removeExistingFavicons() {
    var existingLinks = document.querySelectorAll("link[rel*='icon']");
    var _iterator = _createForOfIteratorHelper(existingLinks), _step;
    try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var link = _step.value;
            link.remove();
        }
    }
    catch (err) {
        _iterator.e(err);
    }
    finally {
        _iterator.f();
    }
};
var useFavicon = function useFavicon(header_logo) {
    var shouldShow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var previousLogoRef = useRef('');
    var hasSetFaviconRef = useRef(false);
    useEffect(function () {
        // If header_logo is empty and we're in a loading state (transitioning between apps),
        // don't change the favicon to prevent flickering
        if (!header_logo && hasSetFaviconRef.current) {
            // Keep existing favicon during transition
            return;
        }
        // Only update if the logo actually changed or it's the first load
        if (header_logo !== previousLogoRef.current || !hasSetFaviconRef.current) {
            removeExistingFavicons();
            if (header_logo && shouldShow) {
                var _getFaviconProperties = getFaviconProperties(header_logo), href = _getFaviconProperties.href, type = _getFaviconProperties.type;
                createFaviconLink(href, type);
                previousLogoRef.current = header_logo;
            }
            else {
                // Use default favicon.ico from public folder
                createFaviconLink(favicon, 'image/x-icon');
                previousLogoRef.current = '';
            }
            hasSetFaviconRef.current = true;
        }
    }, [header_logo, shouldShow]);
};
export default useFavicon;
